import React from "react";

import CraftActionsModalList from "./craft-actions-modal-list";
import { ModalStandard } from "components/service";
import useWindowDimensions from "components/use-hooks/use-window-dimensions";
import CraftTypeLabel from "../../blocks/craft-type-label";


const CraftActionsModal = ({
        stand,
        craftData,
    changeStatusOn
    }) => {

    const { width } = useWindowDimensions();

    return(
        <div className = "craft-actions-modal-wrap">
            <ModalStandard
                extraClass="craft-actions-modal"
                modalVisible={ craftData }
                title={
                    <>
                        <h3>
                            <CraftTypeLabel
                                type={ craftData.type }
                                title={ craftData.title }
                                preferCustomTitle
                            />
                        </h3>
                        <p> { stand.title } </p>
                    </>
                }
                centered={ !(width <= 768) }
            >
                <CraftActionsModalList
                    stand={ stand }
                    craftData = { craftData }
                    changeStatusOn = { changeStatusOn }
                />
            </ModalStandard>
        </div>
    );
}

export default CraftActionsModal;
